import { useEffect, useRef } from "react";

/**
 * Closes a popover (menu, tooltip) on a press outside it or on Escape.
 *
 * Returns the ref to put on the element that counts as "inside" — the trigger
 * and the popover together, so pressing the trigger again toggles instead of
 * closing and immediately reopening.
 */
export const useDismissable = (open, onClose) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handlePointer = (event) => {
      if (ref.current && !ref.current.contains(event.target)) onClose();
    };
    const handleKey = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", handlePointer);
    document.addEventListener("touchstart", handlePointer);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handlePointer);
      document.removeEventListener("touchstart", handlePointer);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open, onClose]);

  return ref;
};
